import { path, assocPath, compose } from 'ramda';
import template from './coworking-access-type.jade';
import accessTypeItems from '../../../enums/coworking-access-type';
import { patterns } from '../../../services/validationPatterns';
import './coworking-access-type.css';

const getDefaultValue = (timeValue, defaultHoursValue) => {
  // Если не определено время, то выставляем дефолтное значение
  if (timeValue == null || typeof timeValue !== 'string') {
    return defaultHoursValue || '';
  }

  // Если есть значение времени, то парсим строку и выдергиваем часы и минуты
  // и устанавливаем часы по ним
  // использует Date API для более удобного оперирование со временем
  if (typeof timeValue === 'string' && timeValue.match(patterns.time)) {
    let [hours, minutes] = timeValue.split(':');

    // Часы должны быть в диапозоне от 0 до 23,
    // если нет, то приводим к такому виду
    hours = Math.max(0, Math.min(hours, 23));
    // аналогичино, что с минутами, только от 0 до 59
    minutes = Math.max(0, Math.min(minutes, 59));

    // форматируем из "9:41" в "09:41"
    if (Number(hours) < 10) {
      hours = `0${hours}`;
    }

    if (Number(minutes) < 10) {
      minutes = `0${minutes}`;
    }

    return `${hours}:${minutes}`;
  }

  return timeValue ? defaultHoursValue : '';
};

export default angular
  .module('cian.addForm.aboutObjectCoworkingAccessType', [])
  .directive('cianAfAboutObjectCoworkingAccessType', () => ({
    bindToController: {
      ad: '=',
    },
    controller: [
      'deviceService',
      function (deviceService) {
        this.isMobile = deviceService.isMobile;
        this.items = accessTypeItems;

        this.timeFrom = getDefaultValue(path(['coworking', 'workTime', 'timeFrom'], this.ad), '09:00');
        this.timeTo = getDefaultValue(path(['coworking', 'workTime', 'timeTo'], this.ad), '21:00');

        // Если задано и "время с" и "время до"
        // то обрабатываем его и парсим на часы и минуты
        if (this.timeFrom && this.timeTo && path(['coworking', 'accessType'], this.ad)) {
          this.ad.coworking = compose(
            assocPath(['workTime', 'timeFrom'], this.timeFrom),
            assocPath(['workTime', 'timeTo'], this.timeTo),
          )(this.ad.coworking);
        }

        this.onChange = () => {
          this.timeFrom = getDefaultValue(this.timeFrom, '09:00');
          this.timeTo = getDefaultValue(this.timeTo, '21:00');

          if (this.timeFrom && this.timeTo) {
            this.ad.coworking.workTime = { timeFrom: this.timeFrom, timeTo: this.timeTo };
          } else {
            this.ad.coworking.workTime = null;
          }
        };
      },
    ],
    controllerAs: 'accessType',
    template,
  })).name;
